export const ASSSIGNED_AGENT_ID = ['assignedAgent', 'agentId'];
export const ASSSIGNED_AGENT_TYPE = ['assignedAgent', 'agentType'];
export const AUDIT_AGENT_ID = ['auditParams', 'agentType'];
export const AUDIT_PARAMS = ['auditParams'];
export const ASSIGNED_AGENT = ['assignedAgent'];